/** Phone numbers are stored as display text. These keep what people type to characters a phone number can contain. */

const ALLOWED = /[^\d+()\-. ]/g

/** Drops anything that can't be part of a phone number (letters, symbols) as it is typed or pasted. */
export function cleanPhoneInput(input: string): string {
  return input.replace(ALLOWED, '').slice(0, 25)
}

/** A complete US number becomes (513) 444-6113; international (+44 …) and partial numbers are left as typed. */
export function formatPhone(input: string): string {
  const v = input.trim()
  const digits = v.replace(/\D/g, '')
  const international = v.startsWith('+') && !v.startsWith('+1')
  const us = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits
  if (international || us.length !== 10) return v
  return `(${us.slice(0, 3)}) ${us.slice(3, 6)}-${us.slice(6)}`
}

/** Why a non-empty number can't be right, or null when it looks fine. */
export function phoneProblem(input: string): string | null {
  const digits = input.replace(/\D/g, '')
  if (!input.trim()) return null
  if (digits.length < 10) return 'Enter the full number, including area code.'
  if (digits.length > 15) return 'That number looks too long.'
  return null
}
